import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'maskCpf' })
export class CpfPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return ''
    }
    while (value.length < 11) {
      value = '0'.concat(value)
    }
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
  }

}
